import React, { Component } from 'react';
import './index.scss';
import intl from 'react-intl-universal';
import { Image } from 'antd';
import EmptyPic from '@/assets/empty.png';

class Empty extends Component {
    constructor (props) {
        super(props);
    }

    render () {
        const searchEmpty = intl.formatMessage({id: 'SearchEmpty'});
        return (
            <div className="empty" role="status" aria-live="polite">
                <Image width="200" className="template-image" preview={false} src={EmptyPic} alt="" /><br></br>
                {searchEmpty}
            </div>
        )
    }
}

export default Empty;
